/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography, DrawerHeader, DrawerTitle, IconButton,
} from '@one-thd/sui-atomic-components';
import { Close, Refresh } from '@one-thd/sui-icons';
import { AssistantIcon } from '../../shared/assets/AssistantIcon';
import { CHANNELS, createBroadcastChannel } from '../../platform/events/broadcast';

// Deliberately a copy, not a reuse of shell/ShellHeader — see ./README.md's "What it
// reuses, and what it deliberately copies".
export const AssistantHeader = ({ onClose }) => {
  // Fire-and-forget: close immediately, this is the only message this header ever sends.
  const onReset = () => {
    const channel = createBroadcastChannel(CHANNELS.assistant);
    channel.postMessage({ type: 'MAA_RESET' });
    channel.close();
  };

  return (
    <DrawerHeader
      endAdornment={(
        <>
          <IconButton
            aria-label="reset"
            onClick={onReset}
            icon={Refresh}
          />
          <IconButton
            aria-label="close"
            onClick={onClose}
            icon={Close}
          />
        </>
      )}
      title={(
        <DrawerTitle
          disableGutters
          ornament={<AssistantIcon height="24px" width="24px" />}
        >
          <div className="sui-flex sui-justify-center sui-align-center">
            <span>Magic Apron </span>
            <Typography variant="body-xs" color="medium" component="span">
              <span className="sui-align-super sui-pl-1">Beta</span>
            </Typography>
          </div>
        </DrawerTitle>
      )}
      className="drawer-header-div sui-flex-col sui-sticky sui-px-2 sui-pb-2 sui-bg-primary sui-z-200 sui-pt-0 lg:sui-pt-2"
    />
  );
};

AssistantHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};
